export default __webpack_public_path__ + "static/media/briefCase.a6276c0e.png";